export const tooltipDirective = {
	mounted(el, binding) {
		const title = binding.value || el.getAttribute("title");
		if (title) {
			el.setAttribute("title", title);
		}
	},
	updated(el, binding) {
		const title = binding.value || el.getAttribute("title");
		if (title) {
			el.setAttribute("title", title);
		}
	},
};
